import { useEjNotificationsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { EJNotificationsContext } from './types'
import { useRecipientsFn } from 'components/CIMSNotifications/hooks/useRecipientsFn'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<EJNotificationsContext>(
  'EJNotificationsContext'
)

export const useEJNotificationsContext = useContextFn

const EJNotificationsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useEjNotificationsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId: projectId },
  })
  const recipients = useRecipientsFn({
    data,
    getter: (id, { ejNotifications }) =>
      ejNotifications.records.find(
        ({ notificationEventId }) => id === notificationEventId
      )?.recipients,
    fallback: { __typename: 'EJNotificationRecipients', every: null },
  })
  return (
    <Provider
      value={{
        refetch,
        loading,
        notifications: data?.ejNotifications.records ?? [],
        recipients,
      }}
    >
      {children}
    </Provider>
  )
}

export default EJNotificationsProvider
